import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetTradePotentialCard";
/**
 * ⑨ 交易潜力统计卡。 Figma：94103:23792
 */

import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { cn } from "utils";
import { SignalCardShell } from "./SignalCardShell";
import type { PriceChangeDirection, SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetTradePotentialCardProps extends SignalCardAssetProps {
  potentialPercent: string;
  entryPrice: string;
  stopLossPrice: string;
  currentReturn: string;
  direction?: PriceChangeDirection;
}

export const AssetTradePotentialCard: React.FC<
  AssetTradePotentialCardProps
> = ({
  potentialPercent,
  entryPrice,
  stopLossPrice,
  currentReturn,
  direction = "up",
  ...asset
}) => {
  const isUp = direction !== "down";

  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-0.5">
            <OspIcons
              name={isUp ? "trending-up" : "trending-down"}
              size={24}
              className={cn(
                isUp
                  ? "text-content_accent1_primary"
                  : "text-content_accent2_primary",
              )}
            />
            <span
              className={cn(
                "headline_regular_l",
                isUp
                  ? "text-content_accent1_primary"
                  : "text-content_accent2_primary",
              )}
            >
              {potentialPercent}
            </span>
          </div>
          <span className="body_s text-content_tertiary">
            {I18n.t("Potential")}
          </span>
        </div>
        <div className="flex w-32 flex-col gap-0 body_medium_s">
          <div className="flex items-center justify-between">
            <span className="body_s text-content_tertiary">
              {I18n.t("Entry")}
            </span>
            <span className="body_medium_s text-content_primary">
              {entryPrice}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="body_s text-content_tertiary">
              {I18n.t("Stop Loss")}
            </span>
            <span className="body_medium_s text-content_primary">
              {stopLossPrice}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="body_s text-content_tertiary">
              {I18n.t("Current")}
            </span>
            <span
              className={cn("body_medium_s", {
                "text-content_accent1_primary": currentReturn.startsWith("+"),
                "text-content_accent2_primary": currentReturn.startsWith("-"),
              })}
            >
              {currentReturn}
            </span>
          </div>
        </div>
      </div>
    </SignalCardShell>
  );
};
